import React, { useState, useMemo, forwardRef } from "react"
import BaseTable from "./BaseTable"
import { getNextSortState, getSortedDataSource } from "@/utilities"

const AtomicTable = ({ dataSource, columns, isLoading, ...props }, fwfRef) => {
    const [sorter, setSorter] = useState({})

    const _dataSource = useMemo(
        () => getSortedDataSource(dataSource, sorter, columns),
        [dataSource, sorter, columns]
    )

    const handleSorting = (key) => setSorter((prev) => getNextSortState(prev, key))

    return (
        <BaseTable
            ref={fwfRef}
            {...props}
            dataSource={_dataSource}
            columns={columns}
            isLoading={isLoading}
            sorter={sorter}
            onSort={handleSorting}
        />
    )
}

export default forwardRef(AtomicTable)
